import React from 'react';
import { Box, Flex, Image } from '@chakra-ui/react';

const Header = () => {
  return (
    <Box
      as="header"
      position="fixed"
      top="0"
      left="0"
      width="100%"
      bg="transparent"
      zIndex="10"
      px="2%"
      mt="15px"
      py="10px"
    >
      <Flex
        alignItems="center"
        justifyContent="space-between"
      >
        {/* Logo a la izquierda */}
        <Box>
          <Image src="/logo.png" alt="Logo" height="50px" />
        </Box>

        {/* Placeholder para agregar más contenido a la derecha si lo necesitas */}
        <Box display={{ base: 'none', md: 'block' }}>
          {/* Aquí podrías agregar enlaces o íconos si lo necesitas */}
        </Box>
      </Flex>
    </Box>
  );
};

export default Header;
